import { useViewStateStore } from '@/state/viewStateStore';

type AuthStatus =
  | { kind: 'pending' }
  | { kind: 'ok' }
  | { kind: 'error'; message: string };

export function StatusBar({ auth }: { auth: AuthStatus }) {
  const coords = useViewStateStore((s) => s.coords);
  const scale = useViewStateStore((s) => s.scale);
  const zoom = useViewStateStore((s) => s.zoom);

  const portalLabel =
    auth.kind === 'pending'
      ? 'Connecting…'
      : auth.kind === 'ok'
        ? 'Portal connected'
        : `Portal: ${auth.message}`;

  return (
    <footer className="flex h-7 items-center justify-between gap-4 border-t border-border bg-background px-3 text-[11px] text-muted-foreground">
      <div className="truncate">{portalLabel}</div>
      <div className="flex items-center gap-4 font-mono tabular-nums">
        <span>{formatCoords(coords)}</span>
        <span>{formatScale(scale)}</span>
        <span>{formatZoom(zoom)}</span>
      </div>
    </footer>
  );
}

function formatCoords(coords: ReturnType<typeof useViewStateStore.getState>['coords']): string {
  if (!coords) return 'x —, y —';
  if (coords.wkid === 4326) {
    return `lon ${coords.x.toFixed(5)}°, lat ${coords.y.toFixed(5)}°`;
  }
  return `x ${coords.x.toFixed(2)}, y ${coords.y.toFixed(2)}`;
}

function formatScale(scale: number | null): string {
  if (scale == null) return 'scale —';
  return `1:${Math.round(scale).toLocaleString()}`;
}

function formatZoom(zoom: number | null): string {
  if (zoom == null) return 'z —';
  return `z ${zoom.toFixed(1)}`;
}
